import { render, staticRenderFns } from "./uploadHomeworkList.vue?vue&type=template&id=3b577078&scoped=true"
import script from "./uploadHomeworkList.vue?vue&type=script&lang=js"
export * from "./uploadHomeworkList.vue?vue&type=script&lang=js"
import style0 from "./uploadHomeworkList.vue?vue&type=style&index=0&id=3b577078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b577078",
  null
  
)

export default component.exports